import { BUTTON_HEIGHT_TILES, ButtonDefSchema, type EntityDef } from '@md/shared';
import { aabbTouches } from '../physics/aabb.js';
import { bodyAabb } from '../physics/body.js';
import { createEntity, ENTITY_PHASE_SENSOR, type EntityInstance, entityAabb } from './entity.js';

/**
 * Bouton-poussoir générique (concept §3.2).
 *
 * Actif tant qu'un robot **ou** un objet solide (un bloc métallique posé
 * dessus) le presse — c'est ce qui permet de « bloquer » une porte ouverte
 * après le départ du robot.
 */
export function createButton(def: EntityDef): EntityInstance {
  const cfg = ButtonDefSchema.parse(def);
  return createEntity({
    id: cfg.id,
    type: 'button',
    x: cfg.x,
    y: cfg.y + 1 - BUTTON_HEIGHT_TILES,
    w: cfg.width,
    h: BUTTON_HEIGHT_TILES,
    phase: ENTITY_PHASE_SENSOR,
    flags: { active: 0 },
    appearance: { shape: 'plate', tint: 0x6b7899, activeTint: 0x8bf7c8 },
    update(self, ctx) {
      const plate = entityAabb(self);
      let pressed = false;
      for (const player of ctx.players) {
        if (!player.dead && aabbTouches(bodyAabb(player.body), plate)) {
          pressed = true;
        }
      }
      if (!pressed) {
        for (const other of ctx.entities) {
          if (other !== self && other.solid && aabbTouches(entityAabb(other), plate)) {
            pressed = true;
            break;
          }
        }
      }
      self.flags.active = pressed ? 1 : 0;
    },
  });
}
